import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "output", "display"]

  connect() {
    if (this.hasInputTarget) this.update()
  }

  update(event) {
    const input = event?.target || this.inputTarget
    if (this.hasOutputTarget) {
      this.outputTarget.textContent = `${input.value}%`
    }
    if (this.hasDisplayTarget) {
      const value = Math.round(input.value * 100)
      this.displayTarget.textContent = `${value}%`
    }
  }
}
